import { motion } from 'framer-motion';
import { X, MessageCircle, Store } from 'lucide-react';
import { LOJAS, linkWhatsApp } from '../data/produtos';

export default function StoreChooser({ produto, onFechar }) {
  const escolher = (loja) => {
    window.open(linkWhatsApp(loja, produto), '_blank', 'noopener,noreferrer');
    onFechar();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-mk-bluedark/70 backdrop-blur-sm sm:p-6"
      onClick={onFechar}
    >
      <motion.div
        data-testid="store-selector-modal"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 40 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-t-3xl sm:rounded-3xl bg-white p-6 shadow-2xl"
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading text-lg sm:text-xl font-extrabold text-slate-900">
              Escolha a loja para atendimento
            </h3>
            <p className="mt-1 text-sm text-slate-500">
              {produto
                ? `Sobre: ${produto.nome}`
                : 'Fale diretamente com a nossa equipe.'}
            </p>
          </div>
          <button
            data-testid="store-selector-close-button"
            onClick={onFechar}
            aria-label="Fechar"
            className="rounded-full p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
          >
            <X size={18} />
          </button>
        </div>

        <div className="mt-5 space-y-3">
          {LOJAS.map((loja, i) => (
            <button
              key={loja.id}
              data-testid={`store-option-loja${i + 1}`}
              onClick={() => escolher(loja)}
              className="group flex w-full items-center gap-4 rounded-2xl border-2 border-slate-200 p-4 text-left transition-colors duration-300 hover:border-mk-green hover:bg-mk-greensoft"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-mk-blue text-white transition-colors duration-300 group-hover:bg-mk-green">
                <Store size={22} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-heading text-base font-bold text-slate-900">{loja.nome}</span>
                <span className="block text-sm text-slate-500">{loja.cidade}</span>
                <span className="mt-0.5 block text-sm font-semibold text-mk-green">{loja.telefone}</span>
              </span>
              <MessageCircle size={20} className="shrink-0 text-mk-green" />
            </button>
          ))}
        </div>

        <p className="mt-4 text-center text-xs text-slate-400">
          A conversa abre no WhatsApp com a mensagem já preenchida.
        </p>
      </motion.div>
    </motion.div>
  );
}
